// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2tNMi","label":"Section_label__2YkWU","contentWrap":"Section_contentWrap__2fB-N","footer":"Section_footer__20vv7","footerInner":"Section_footerInner__AGAW3"};